import { CellConfig } from "shared/components/UniversalTable/components/UniversalTableRow";
import { PencilSimple, TrashSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  CompanyEquipment,
  CompanyEquipmentType,
  EQUIPMENT_TYPE_LABELS,
  EQUIPMENT_TYPE_COLORS,
} from "../types/companyEquipment";

interface CompanyEquipmentCellHandlers {
  onEditClick: (row: CompanyEquipment) => void;
  onDeleteClick: (row: CompanyEquipment) => void;
}

export const createCompanyEquipmentCells = (
  row: CompanyEquipment,
  handlers?: CompanyEquipmentCellHandlers,
): CellConfig[] => {
  const typeBadge = row.companyEquipmentType ? (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${EQUIPMENT_TYPE_COLORS[row.companyEquipmentType as CompanyEquipmentType]}`}
    >
      {EQUIPMENT_TYPE_LABELS[row.companyEquipmentType as CompanyEquipmentType]}
    </span>
  ) : (
    <span className="text-neutral-secondary-mid text-sm">-</span>
  );

  return [
    {
      id: "id",
      content: (
        <span className="text-neutral-primary text-sm font-medium">
          {row.id}
        </span>
      ),
    },
    {
      id: "serialNumber",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.serialNumber || "-"}
        </span>
      ),
    },
    {
      id: "companyEquipmentType",
      content: typeBadge,
    },
    {
      id: "company",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.companyName || "-"}
        </span>
      ),
    },
    {
      id: "inUseBy",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.inUseBy || (
            <span className="text-neutral-secondary-mid">Niet toegewezen</span>
          )}
        </span>
      ),
    },
    {
      id: "actions",
      content: (
        <div className="flex justify-end gap-1">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={(e) => {
              e.stopPropagation();
              handlers?.onEditClick(row);
            }}
          >
            <PencilSimple size={16} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-brick-primary hover:text-brick-primary"
            onClick={(e) => {
              e.stopPropagation();
              handlers?.onDeleteClick(row);
            }}
          >
            <TrashSimple size={16} />
          </Button>
        </div>
      ),
    },
  ];
};
